import type { Activity } from '@/scripts/data/types'
import { GlobalState } from '@/scripts/config/globalState'
import { isArchive, nowDayNumber } from '@/scripts/config/settings'

export type Phase = 1 | 2

function getValidDayNumber(day: number | undefined | null): number {
  // If undefined, null, or not a number, fallback to 1
  if (day === undefined || day === null || typeof day !== 'number' || isNaN(day)) {
    return 1
  }

  // Clamp between 1 and 24
  return Math.max(1, Math.min(24, day))
}

const State = {
  initialized: false,
  // Archive version of the calendar must start on day 1
  day: isArchive ? 1 : (getValidDayNumber(nowDayNumber) as number), // 1..24
  phase: 1 as Phase, // 1 or 2
  manifestLoaded: false,
  foregroundDays: new Set<number>(),
  embla: null as {
    selectedScrollSnap: () => number
    scrollTo: (index: number, jump?: boolean) => void
    scrollPrev: () => void
    scrollNext: () => void
    on: (event: string | unknown, callback: () => void) => unknown
    [key: string]: unknown
  } | null,
  rootEl: null as HTMLElement | null,
  refs: {
    phaseArea: null as HTMLDivElement | null,
    btnPrev: null as HTMLButtonElement | null,
    btnNext: null as HTMLButtonElement | null,
    btnMusic: null as HTMLButtonElement | null,
    preloaderEl: null as HTMLElement | null,
    activityButton: null as HTMLButtonElement | null,
    activityModalContent: null as HTMLElement | null,
    emblaContainer: null as HTMLDivElement | null,
  },
}

export function getActivityForDay(d: number): Activity | undefined {
  return (GlobalState.activities || []).find((a) => a.day === d)
}

export default State
